export default {
    data: () => ({
        someElementIsFloating: false,
        floatingTimeout: null,
        descendingTimeout: null
    }),

    methods: {
        floatElement(e) {
            e.target.classList.remove("descending");
            if (this.someElementIsFloating) {
                this.floatingTimeout = setTimeout(function () {
                    e.target.classList.add("floating");
                }, 155);
            } else {
                e.target.classList.add("floating");
            }
            this.someElementIsFloating = true;
        },

        unfloatElement(e) {
            e.target.classList.remove("floating");
            e.target.classList.add("descending");
            clearTimeout(this.floatingTimeout);
            this.descendingTimeout = setTimeout(function () {
                e.target.classList.remove("descending");
                this.someElementIsFloating = false;
            }, 150);
        }
    }
}